'use client'

import React from 'react'
import { Twitter, Linkedin, Youtube } from 'lucide-react'

// Simple social media links component

interface SocialMediaLinksProps {
  className?: string
}

const SocialMediaLinks: React.FC<SocialMediaLinksProps> = ({
  className = ''
}) => {
  const socialLinks = [
    {
      name: 'Twitter',
      url: 'https://twitter.com/100xprompt',
      icon: Twitter,
      color: 'hover:text-blue-400',
      bgColor: 'hover:bg-blue-400/10'
    },
    {
      name: 'LinkedIn',
      url: 'https://linkedin.com/company/100xprompt',
      icon: Linkedin,
      color: 'hover:text-blue-600',
      bgColor: 'hover:bg-blue-600/10'
    },
    {
      name: 'YouTube',
      url: 'https://youtube.com/@100xprompt',
      icon: Youtube,
      color: 'hover:text-red-500',
      bgColor: 'hover:bg-red-500/10'
    }
  ]

  return (
    <div className={`flex items-center justify-center gap-4 ${className}`}>
      {socialLinks.map((social) => {
        const IconComponent = social.icon
        return (
          <a
            key={social.name}
            href={social.url}
            target="_blank"
            rel="noopener noreferrer"
            aria-label={`Visit our ${social.name} page`}
            title={`Follow us on ${social.name}`}
            className={`
              p-3 rounded-xl bg-gray-800/50 border border-gray-600/30
              text-gray-300 ${social.color} ${social.bgColor}
              transition-all duration-300 hover:scale-110
              backdrop-blur-sm hover:border-white/20
            `}
          >
            <IconComponent className="w-6 h-6" aria-hidden="true" />
          </a>
        )
      })}
    </div>
  )
}

export default SocialMediaLinks